// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"ecc95867","387":"971de5a0","404":"65bedcb1","443":"93731219","472":"e7954484","532":"783aaa87","608":"c8be1124","612":"1d922a52","738":"b04df41b","787":"7da95b79","919":"9aa2a3b6"}[chunkId] + ".chunk.js";
};